<template>
	<div id="player"></div>
</template>

<script>
/* eslint no-undef: "off" */

export default {
	props: ['options'],
	data() {
		return {
			player: null,
		};
	},
	watch: {
		options: {
			handler() {
				this.reloadPlayer();
			},
			deep: true,
		},
	},
	mounted() {
		this.initPlayer();
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
      this.player = null;
    }
  },
	methods: {
		initPlayer() {
      this.player = bytearkPlayer('player', this.options);
		},
		reloadPlayer() {
      if (this.player) {
        this.player.dispose();
        this.player = null;
      }

      this.initPlayer();
    },
	},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/themes/helper.scss';

#player {
	@extend .shadow;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/byteark-player/PreviewBytearkPlayer.vue